import { useState } from "react";

const ProductCard = ({ image, title, content, price }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative w-[280px] h-[480px] mx-auto group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>

        <div className={`w-full h-[300px] bg-center bg-cover rounded-xl transition-transform duration-500 ease-in-out ${ isHovered ? "scale-105" : "scale-100"}`}
          style={{
            backgroundImage: `url(${image})`,
          }}></div>
          
        <div className={`flex flex-col items-center transition-transform duration-500 ease-in-out text-[#41220E] font-montserrat pt-2`}>
            <div className="w-full">
                <h3 className="text-[18px] sm:text-[20px] font-semibold mb-2"> {title} </h3>
                <p className="font-normal text-[14px] mb-2"> {content} </p>
            </div>
            <div className="w-full flex items-center">
                <p> Qr. {price} .00 </p>
            </div>
        </div>
    </div>
  );
};

export default ProductCard;
